import React from "react";
import {useSelector} from "react-redux";

import {mt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../../app/rp_reducer";
import {OfferType} from "../../../types/OfferType";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {ParagraphType} from "../../helpers/location_generic_description/constants";
import {getLocationGenericDescription} from "../../helpers/location_generic_description/get_location_generic_description";
import {offerListDescriptionHolder} from "../OfferListSeoDescription";
import {ParagraphListType} from "./ParagraphRenderer/ParagraphListType";
import {ParagraphTextType} from "./ParagraphRenderer/ParagraphTextType";

interface IProps {
    className?: string;
    offerType: OfferType;
    filters?: {
        region?: string[];
        type?: number;
        rooms_1?: number;
    } | null;
    region: ISelectedRegion;
}

const allowedFilters = ["region", "type", "rooms_1"];

export const OfferListGenericLocationDescription = (props: IProps) => {
    const selectedRegionEstimatedPrices = useSelector((state: IRPStore) => state.offerList.selectedRegionEstimatedPrices);
    const forbiddenFilters = Object.keys(props.filters || {}).filter((filterName) => !allowedFilters.includes(filterName));

    // only allowed "-jednopokojowe"
    if (forbiddenFilters.length > 0 || (props.filters?.rooms_1 && props.filters?.rooms_1 !== 1)) {
        return null;
    }

    const sections = getLocationGenericDescription({
        offerType: props.offerType,
        filters: props.filters,
        region: props.region,
        selectedRegionEstimatedPrices
    });

    if (!Array.isArray(sections) || sections.length === 0) {
        return null;
    }

    return (
        <div css={[offerListDescriptionHolder]} className={props.className}>
            {sections?.map((section, sectionIndex) => (
                <React.Fragment key={section.headline}>
                    <Text as="h2" variant="headline_4" mb={2} css={[sectionIndex > 0 ? mt(3) : ""]}>
                        {section.headline}
                    </Text>

                    {section.paragraphs.map((paragraph, index) => (
                        <React.Fragment key={index}>
                            {paragraph.type === ParagraphType.TEXT ? <ParagraphTextType text={paragraph.text} /> : null}
                            {paragraph.type === ParagraphType.LIST ? <ParagraphListType texts={paragraph.text} /> : null}
                        </React.Fragment>
                    ))}
                </React.Fragment>
            ))}
        </div>
    );
};
